<template>
  <div>
    <el-row id="content-title">
      <el-col :span="24">
        <div class="d-flex align-items-center">
          <h3 class="mb-0">Dashboard</h3>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row v-show="isAdmin"> -->
    <!-- <default-dashboard v-if="user && user.user_type != 4"></default-dashboard> -->
    <supervisor-dashboard></supervisor-dashboard>
  </div>
</template>

<script>
// import DefaultDashboard from "./dashboard/default.vue";
import SupervisorDashboard from "./dashboard/supervisor.vue";
export default {
  data: () => ({}),
  name: "home",
  components: { SupervisorDashboard },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    isAdmin() {
      if (this.$store.getters["auth/user"].user_type == 1) return true;
      return false;
    }
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
::v-deep {
  .card-holder {
    display: flex;
    flex-direction: row;
    width: 100%;
    font-family: "Roboto", sans-serif;
  }
  .box-card {
    flex-grow: 1;
    &.box-success {
      background-color: #67c23a;
      color: #fff;
    }
    &.box-primary {
      background-color: #409eff;
      color: #fff;
    }
    &.box-warning {
      background-color: #e6a23c;
      color: #fff;
    }
    &.box-info {
      background-color: #909399;
      color: #fff;
    }
    &:not(:first-child) {
      margin-left: 20px;
    }
    .box-content__wrapper {
      // height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .box-content {
        font-size: 60px;
        // line-height: 100px;
      }
      .box-header {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 10px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .box-card {
      .box-content__wrapper .box-content {
        font-size: 80px;
      }
    }
  }
  @media screen and (max-width: 425px) {
    .card-holder {
      flex-direction: column;
    }
    .box-card {
      &:not(:first-child) {
        margin-left: 0;
        margin-top: 15px;
      }
      .box-content__wrapper {
        height: auto;
        .box-content {
          font-size: 60px;
          line-height: 80px;
        }
      }
    }
  }
}
</style>
